import { useQueryClient } from '@tanstack/react-query';

import { useWelcomeQuery } from '../api/getWelcomeDetails';
import { unlockPolicyPBE } from '../api/legacy/unlockPolicyPBE';
import { getCookie } from '../utils/helpers';

const useUnlockPolicy = (): {
  unlockPolicy: () => Promise<void>;
  custKey?: string;
  lockedPolicyNumber?: string;
} => {
  const queryClient = useQueryClient();
  const lockedPolicyNumber = getCookie('lockedpolicynumber');
  const { data: welcomeData } = useWelcomeQuery();
  const custKey = welcomeData?.userInfo.custKey ?? '';

  const unlockPolicy = async () => {
    try {
      if (lockedPolicyNumber) {
        await unlockPolicyPBE(lockedPolicyNumber, custKey, welcomeData?.mdmId);
        document.cookie = `lockedpolicynumber=;`;
        await queryClient.invalidateQueries({
          queryKey: ['policies'],
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return { unlockPolicy, custKey, lockedPolicyNumber };
};

export default useUnlockPolicy;
